export function formatLeagueName(league) {
    const leagueMap = {
        fran: 'LIGUE 1',
        liga: 'LIGA',
        chlg: 'CHAMPIONS\nLEAGUE',
        bund: 'BUNDESLIGA',
        seri: 'SERIE A',
        bpl: 'BPL',
        mls: 'MLS',
        euro: 'EURO',
        oly_msoc: 'OLY MSOC',
        oly_wsoc: 'OLY WSOC',
        eng_fa_cup: 'FA CUP',
    }
    return leagueMap[league] || ''
}

export function orderSoccerLeagues(leagues) {
    const desiredOrder = [
        'eng_fa_cup',
        'oly_msoc',
        'oly_wsoc',
        'euro',
        'bpl',
        'chlg',
        'bund',
        'mls',
        'liga',
        'seri',
        'fran',
    ]
    const newOrder = {}
    desiredOrder.forEach(league => {
        if (leagues[league]) {
            newOrder[league] = leagues[league]
        }
    })
    return newOrder
}

export function getSoccerLeagueSlug(league) {
    const leagueMap = {
        'ligue-1': 'fran',
        'la-liga': 'liga',
        'champions-league': 'chlg',
        bundesliga: 'bund',
        'serie-a': 'seri',
        'premier-league': 'bpl',
    }
    if (leagueMap[league]) {
        return leagueMap[league]
    } else {
        return league
    }
}

export function formatGameStats(homeTeam, visitingTeam, coverageLevel) {
    if (!visitingTeam.game_stats || !homeTeam.game_stats || coverageLevel < 4) {
        return []
    }

    const statCategories = [
        {
            title: 'Shots',
            valueKey: 'shots',
        },
        {
            title: 'On Target',
            valueKey: 'shots_on_goal',
        },
        {
            title: 'Corners',
            valueKey: 'corner_kicks',
        },
        {
            title: 'Crosses',
            valueKey: 'crosses',
        },
        {
            title: 'Fouls',
            valueKey: 'fouls',
        },
        {
            title: 'Offsides',
            valueKey: 'offsides',
        },
        {
            title: 'Yellow Cards',
            valueKey: 'yellow_cards',
        },
        {
            title: 'Red Cards',
            valueKey: 'red_cards',
        },
        {
            title: 'Possession %',
            valueKey: 'possession_percentage',
            valueFormatter: n => `${n}%`,
        },
    ]

    const gameStats = statCategories.map(statCategory => {
        let homeTeamValue = homeTeam.game_stats[statCategory.valueKey]
        let visitingTeamValue = visitingTeam.game_stats[statCategory.valueKey]

        if (typeof homeTeamValue === 'string' || homeTeamValue instanceof String) {
            homeTeamValue = parseFloat(homeTeamValue) || 0
        }
        if (typeof visitingTeamValue === 'string' || visitingTeamValue instanceof String) {
            visitingTeamValue = parseFloat(visitingTeamValue) || 0
        }

        if (
            (!homeTeamValue && homeTeamValue !== 0) ||
            (!visitingTeamValue && visitingTeamValue !== 0)
        ) {
            return null
        }

        if (coverageLevel < 6 && statCategory.valueKey === 'possession_percentage') {
            return null
        }

        return {
            title: statCategory.title,
            homeTeamValue: homeTeamValue,
            visitingTeamValue: visitingTeamValue,
            valueFormatter: statCategory.valueFormatter,
        }
    })
    return gameStats.filter(n => n) // filter out null values
}
